import React, { useEffect, useState } from 'react';
import { Button, Spinner, Toast, ToastContainer, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FaLayerGroup, FaUsers } from 'react-icons/fa';
import { TbCopy } from 'react-icons/tb';
import { RoleResponseModel, UserModel } from '../../_core/_model.ts';
import { GetUserRoles } from '../../_core/_request.ts';
import { useAppContext } from '../../context/AppContext.tsx';
import { RoleGroup } from './_core/_model';
import { LabelConstants } from '../../Constants.ts';
import { AutoSelectDropdown } from '../Tools/AutoSelectDropdown.tsx';
import { getUserName } from '../../Utilities/Utilities.ts';
import { useJoyride } from '../../UIComponents/JoyrideTour/JoyrideContext.tsx';

interface tabs {
  name: 'user' | 'group' | 'manual',
  title: string,
  selected: boolean
}

interface fromValue {
  from: string,
  fromId: number
}

interface Props {
  allRoles: RoleResponseModel[],
  options: tabs[],
  onChange: (roles: RoleResponseModel[], from: string, fromId: string) => void,
  onTypeChange: (type: 'user' | 'group' | 'manual' | null) => void,
  typeLabel: string,
  replaceOlds: boolean,
  helpLabel: string,
  exUI: any,
  importButton: any
}

const AssignedRolesSelector: React.FC<Props> = ({ allRoles, onChange, onTypeChange, typeLabel, helpLabel, replaceOlds, exUI, options, importButton }) => {
  const [assignedRoles, setAssignedRoles] = useState<RoleResponseModel[]>([]);
  const [mode, setMode] = useState<'user' | 'group' | 'manual' | null>(null);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [users, setUsers] = useState<UserModel[]>([]);
  const [roleGroups, setRoleGroups] = useState<RoleGroup[]>([]);
  const [loadingList, setLoadingList] = useState<boolean>(false);
  const [loadingRoles, setLoadingRoles] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<{ msg: string, error: boolean } | null>(null);
  const { allUsers, allRoleGroups } = useAppContext();
  const { setSelectedTab } = useJoyride();
  useEffect(() => {

    setSelectedTab(mode);
  }, [mode]);

  useEffect(() => {
    let s = options.find((o) => o.selected);
    if (typeof s != 'undefined' && s.name != mode) {
      setMode(s.name)
      initItems(s.name);
    }
  }, [allUsers, allRoleGroups])

  const addRoles = (newRoles: RoleResponseModel[], from: string, fromId: string) => {
    let updated = [...assignedRoles];
    if (replaceOlds)
      updated = [];
    let newlyAddedCount = 0;
    newRoles.forEach(role => {
      if (!updated.find(r => r.roleID === role.roleID)) {
        updated.push(role);
        newlyAddedCount++;
      }
    });
    setAssignedRoles(updated);
    onChange(updated, from, fromId);
    if (newlyAddedCount > 0) {
      setToastMessage({ msg: `${newlyAddedCount} role${newlyAddedCount > 1 ? 's' : ''} imported from ${from}`, error: false });
    } else {
      setToastMessage({ msg: `No new roles to import from ${from}`, error: true });
    }
    return updated;
  };

  const initItems = (m: 'user' | 'group' | 'manual' | null) => {
    setLoadingList(true);
    onTypeChange(m);
    if (m === 'group') {
      setRoleGroups(allRoleGroups);
      setLoadingList(false);
    } else if (m == 'user') {
      setUsers(allUsers);
      setLoadingList(false);
    }
    else {
      onChange([], "manual", "")
    }
  }

  const updateMode = (m: 'user' | 'group' | 'manual' | null) => {
    initItems(m);
    setMode(m);
  }

  const removeRole = (roleId: number) => {
    const updated = assignedRoles.filter(role => role.roleID !== roleId);
    setAssignedRoles(updated);
    //onChange(updated);
  };

  const addUsersRole = (u: UserModel, callback: any) => {
    setLoadingRoles(true);
    GetUserRoles(u.userID).then((x) => {
      let roleIds = x.data.map((r) => r.roleID);
      let roles = allRoles.filter((r) => (
        (r.roleID != null) && (roleIds.indexOf(r.roleID) > -1)
      ))
      let updatedRoles = addRoles(roles, `User: ${u.userName}`, u.userID.toString());
      setLoadingRoles(false);
      if (typeof callback != 'undefined')
        callback(updatedRoles, { from: "user", fromId: u.userID });
      //setMode(null);
    })
  }

  const handleAddRoles = (callback: any) => {
    if (mode === 'user') {
      const user = users.find(u => u.userID === selectedId);
      if (user) addUsersRole(user, callback);
    } else if (mode === 'group') {
      const group = roleGroups.find(g => g.roleGroupID === selectedId);
      if (group) {
        setLoadingRoles(true);
        let roles = allRoles.filter((x) => x.roleID != null && group.roleIDS.split(",").includes(x.roleID.toString()));
        let updatedRoles = addRoles(roles, `Group: ${group.roleGroupName}`, group.roleGroupID.toString());
        setTimeout(() => {
          setLoadingRoles(false);
          if (typeof callback != 'undefined')
            callback(updatedRoles, { from: "group", fromId: group.roleGroupID });
          // setMode(null);
        }, 500);
      }
    }
  };

  return (
    <div className="row border rounded-3 px-3 py-2 mx-0 mb-3">
      <div className='col-md-12 mb-1'>
        <div className='d-flex flex-row align-items-center gap-2 t-co'>
          <label className="form-label fw-bold m-0">
            {typeLabel}:
          </label>

          <div>
            <ToggleButtonGroup type="radio" name="mode" value={mode} className=' j_g_rt_copy' >
              {
                options.map((o) => (
                  <ToggleButton id={"mode-" + o.name} className={mode === o.name ? `j_req_t_${mode} active` : `j_req_t_${mode}`} key={"mode-" + o.name} value={o.name} variant="outline-success" onClick={() => {
                    if (mode == o.name) {
                      setMode(null)
                    }
                    else
                      updateMode(o.name);
                    setSelectedId(0);
                  }} >
                    {
                      o.name == "user" ? <FaUsers className="me-1" /> :
                        o.name == "group" ? <FaLayerGroup className="me-1" /> :
                          <FaLayerGroup className="me-1" />

                    }
                    {o.title}
                  </ToggleButton>
                ))
              }
            </ToggleButtonGroup>
          </div>
        </div>
        <small className="text-muted d-flex align-items-center gap-1 mt-2">
          <TbCopy size={14} className="text-secondary" />
          {mode === 'group'
            ? 'Copy roles from any available group ' + helpLabel
            : mode === 'user'
              ? 'Copy roles from any available user ' + helpLabel
              : mode === 'manual'
                ? 'You can assign roles manually from each of available dimensions, to create request.' :
                options.length > 2 ?
                  'Choose whether to copy roles from a group, a user, or assign them manually.'
                  : 'Choose whether to copy roles from a group or a user.'}
        </small>
      </div>
      {mode && mode != "manual" && (
        <div className={`${typeof importButton == 'undefined' ? "col-12 mb-3" : "col-md-6 mb-3"} j_req_cpy_grp j_req_cpy_user `}>
          <label className="form-label fw-bold">{mode == "group" ? "Select a Group to Copy Roles From:" : "Select a User to Copy Roles From:"}  </label>
          <div className='d-flex flex-row align-items-center gap-2'>
            <div className={typeof importButton == 'undefined' ? "" : "flex-grow-1 w-100"} style={{ minWidth: "300px" }}>
              {loadingList ? (
                <div className="d-flex align-items-center gap-2">
                  <Spinner animation="border" size="sm" /> <span>Loading {mode === 'user' ? 'users' : 'groups'}...</span>
                </div>
              ) : (
                <AutoSelectDropdown
                  placeholder={`Select a ${(mode === 'group') ? LabelConstants.RoleGroups : "User"}`}
                  options={(mode === 'user') ? users.map((item) => {
                    return { id: item.userID.toString(), name: getUserName(item) }
                  }) :
                    roleGroups.map((item) => {
                      return { id: item.roleGroupID.toString(), name: item.roleGroupName }
                    })
                  }
                  initSelect={(typeof selectedId != 'undefined' && selectedId != null) ? selectedId.toString() : ""}
                  onSelect={(v) => {
                    setSelectedId(Number(v))
                  }}
                  emptyString=""
                />
              )}
            </div>
            {
              typeof importButton == 'undefined' &&
              <Button variant="outline-secondary py-1" disabled={!selectedId || loadingRoles} onClick={() => {
                handleAddRoles(undefined)
              }}>
                {loadingRoles ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" /> Copying...
                  </>
                ) : (
                  <div className='d-flex flex-row align-items-center gap-1'>
                    <TbCopy size={18} className="me-1" /> Copy Roles
                  </div>
                )}
              </Button>
            }
          </div>
        </div>
      )}
      {
        typeof importButton != 'undefined' &&
        importButton(!selectedId || loadingRoles, handleAddRoles)
      }

      <ToastContainer position="bottom-center" className="p-3 position-fixed z-8">
        <Toast bg={toastMessage?.error ? "warning" : "success"}
          onClose={() => setToastMessage(null)} show={!!toastMessage} delay={5000} autohide>
          <Toast.Body className={toastMessage?.error ? "text-default text-center" : "text-white text-center"}>{toastMessage?.msg}</Toast.Body>
        </Toast>
      </ToastContainer>
      {exUI}
    </div >
  );
};

export default AssignedRolesSelector;